import {
	vxStore
} from "../store/vuex_store"

export function populateToTopStories(array, topStories) {
	if (array.length >= 5) {
		//Retrieve 4 stories from each section
		array.slice(0, 4).forEach(item => {
			topStories.push(item)
		});

		array.slice(4, 5).forEach(item => {
			vxStore.state.stories.data.latestStories.push(item)
		})

		array.slice(5, 6).forEach(item => {
			vxStore.state.stories.data.bigStoryRight.push(item)
		})

		array.slice(6, 7).forEach(item => {
			vxStore.state.stories.data.moreStories.push(item)
		})

	} else {
		//Retrieve 1 story from each section
		array.slice(0, 1).forEach(item => {
			topStories.push(item)
		});
		if (array.length > 1) {
			array.slice(1, array.length).forEach(item => {})
		}
	}
}

export function addCategory(array, category, color) {
	array.forEach(item => {
		item.category = {
			name: category,
			color: color
		};
	});
}

export function startTime(appTime) {
	let today = new Date();
	let h = today.getHours();
	let m = today.getMinutes();
	let s = today.getSeconds();
	let meridian = "AM";

	if (h == 0) {
		h = 12;
	} else if (h > 12) {
		h = h - 12;
		meridian = "PM";
	}

	h = h < 10 ? "0" + h : h;
	m = m < 10 ? "0" + m : m;
	s = s < 10 ? "0" + s : s;

	appTime = `${h}:${m} ${meridian}`;
	setTimeout(startTime, 1000);
}

export function getDate(appDate) {
	const months = [
		"Jan",
		"Feb",
		"Mar",
		"Apr",
		"May",
		"June",
		"July",
		"Aug",
		"Sept",
		"Oct",
		"Nov",
		"Dec"
	];
	const days = ["Sun", "Mon", "Tue", "Wed", "Thur", "Fri", "Sat"];

	let today = new Date();
	let day = days[today.getDay()];
	let date = today.getDate();
	let month = months[today.getMonth()];
	let year = today.getFullYear();

	let todayDate = `${day} ${month} ${date}, ${year}`;

	appDate = todayDate;
}



// WEBPACK FOOTER //
// ./src/resources/utilities.js